import React, { useEffect, useRef, useState } from 'react';

import { AnimatePresence, motion } from 'framer-motion';
import { useLocation } from 'react-router-dom';

import LoadingLogo from '../LoadingLogo/LoadingLogo';

/* ------------------------------------------------------------------
   NAVIGATION LOADING OVERLAY
   Shows the branded LoadingLogo spinner over the current page for a
   brief beat whenever the route changes, so page-to-page navigation
   gets the same visual treatment as the splash screen instead of an
   abrupt cut. Skips the very first render (that's the splash screen's
   job) and guarantees a minimum visible time so fast transitions don't
   flash.
------------------------------------------------------------------- */

const MIN_VISIBLE_MS = 450;

export default function NavigationLoadingOverlay() {
  const location = useLocation();
  const [visible, setVisible] = useState(false);
  const isFirstRender = useRef(true);

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }
    setVisible(true);
    const timer = setTimeout(() => setVisible(false), MIN_VISIBLE_MS);
    return () => clearTimeout(timer);
  }, [location.pathname]);

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          key="navigation-loading-overlay"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.2 }}
          style={{
            position: 'fixed',
            inset: 0,
            zIndex: 9998,
            background: 'rgba(0,0,0,0.5)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <LoadingLogo size={88} />
        </motion.div>
      )}
    </AnimatePresence>
  );
}
